import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CreateUserDTO, User, UserFullInfo } from 'src/app/user/model/user';
import { environment } from 'src/environments/environment';
import { WritableSignal, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  http = inject(HttpClient);

  public userSignal: WritableSignal<UserFullInfo | null> = signal(null);

  getConnectedUser(): void {
    this.http.get<UserFullInfo>(`${environment.apiUrl}/me`).subscribe({
      next: (user) => {
        this.userSignal.update(() => user);
      },
      error: (err) => {
        console.error('Failed to load connected user:', err);
      },
    });
  }
  isAdmin() {
    const user = this.userSignal();
    return user ? user.role === 'admin' || user.role === 'superAdmin' : false;
  }

  create(user: CreateUserDTO): Observable<User> {
    return this.http.post<User>(`${environment.apiUrl}/user`, user);
  }

  getUser(userId: string): Observable<UserFullInfo> {
    return this.http.get<UserFullInfo>(`${environment.apiUrl}/user/${userId}`);
  }
  get allUsers(): Observable<User[]> {
    return this.http.get<User[]>(`${environment.apiUrl}/user`);
  }

  update(userId: string, user: CreateUserDTO): Observable<User> {
    return this.http.put<User>(`${environment.apiUrl}/user/${userId}`, user);
  }

  delete(userId: string): Observable<{ message: string; id: string }> {
    return this.http.delete<{ message: string; id: string }>(
      `${environment.apiUrl}/user/${userId}`,
    );
  }

  triggerPasswordReset(userId: string): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(
      `${environment.apiUrl}/user/${userId}/reset-password`,
      {},
    );
  }
}
